/**
 * API utility functions
 */

/**
 * Returns the appropriate API endpoint based on environment
 */
export const getAPIEndpoint = () => {
  // For development environment
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_URL || 'https://xin7-2on4-t5ue.n7.xano.io/api:bIID2SK9';
  }
  
  // For production environment
  return process.env.REACT_APP_API_URL || 'https://xin7-2on4-t5ue.n7.xano.io/api:bIID2SK9';
}; 